import { Link } from "react-router-dom";
import { CONTACT_INFO, SERVICES } from "@/data/content";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      className="border-t border-[color:var(--gs-line)] bg-[color:var(--gs-navy-950)]"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[var(--container-max)] px-4 py-14 sm:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3">
              <img src="/logo-small.png" alt="GrowthSync Solutions logo" className="h-12 w-12 rounded-lg" />
              <div>
                <p className="font-display text-base font-bold leading-tight">
                  <span className="text-white">Growth</span>
                  <span className="text-[color:var(--gs-gold-400)]">Sync</span>
                </p>
                <p className="text-[10px] uppercase tracking-[0.3em] text-white/60">Solutions</p>
              </div>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-white/50">
              Full-service marketing & BPO company in Dhaka, Bangladesh. Strategize.
              Connect. Grow.
            </p>
          </div>

          {/* Services (first 5) */}
          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-[color:var(--gs-gold-400)]">
              Services
            </h4>
            <ul className="mt-4 space-y-2">
              {SERVICES.slice(0, 5).map((s) => (
                <li key={s.name}>
                  <Link
                    to={`/${s.slug}`}
                    data-testid="footer-service-link"
                    className="text-sm text-white/60 hover:text-white"
                  >
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* More services */}
          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-[color:var(--gs-gold-400)]">
              More
            </h4>
            <ul className="mt-4 space-y-2">
              {SERVICES.slice(5).map((s) => (
                <li key={s.name}>
                  <Link
                    to={`/${s.slug}`}
                    data-testid="footer-service-link"
                    className="text-sm text-white/60 hover:text-white"
                  >
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-[color:var(--gs-gold-400)]">
              Contact
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-white/60">
              <li className="flex items-start gap-2.5">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-[color:var(--gs-gold-400)]" />
                <a href={`tel:${CONTACT_INFO.phoneRaw}`} className="hover:text-white">
                  {CONTACT_INFO.phone}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-[color:var(--gs-gold-400)]" />
                <a href={`mailto:${CONTACT_INFO.email}`} className="break-all hover:text-white">
                  {CONTACT_INFO.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[color:var(--gs-gold-400)]" />
                <span className="leading-relaxed">{CONTACT_INFO.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="gold-hairline mt-12" />
        <div className="mt-6 flex flex-col items-center justify-between gap-3 sm:flex-row">
          <p className="text-xs text-white/40" data-testid="footer-copyright">
            © {new Date().getFullYear()} GrowthSync Solutions. All rights reserved.
          </p>
          <p className="text-xs uppercase tracking-[0.25em] text-[color:var(--gs-gold-400)]/70">
            Strategize • Connect • Grow
          </p>
        </div>
      </div>
    </footer>
  );
};
